import React from 'react'

import AboutUs from '../components/Pages/AboutUs'

const AboutUsPage = ({ location }) => {
  return <AboutUs location={location} localeID="sk_SK" />
}

export default AboutUsPage
